export function formatAccountingCurrency(amount) {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount || 0);
}

export function formatAccountingDate(dateString) {
  if (!dateString) return '-';

  return new Date(dateString).toLocaleDateString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function getPaymentStatusMeta(status) {
  switch (status) {
    case 'incassato':
      return { label: 'Incassato', className: 'bg-[var(--success-soft)] text-[var(--success-text)] border-[var(--success-border)]' };
    case 'previsto':
      return { label: 'Previsto', className: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]' };
    case 'in_ritardo':
      return { label: 'In Ritardo', className: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]' };
    default:
      return { label: status, className: '' };
  }
}

export function getExpenseStatusMeta(status) {
  switch (status) {
    case 'pagato':
      return { label: 'Pagato', className: 'bg-[var(--success-soft)] text-[var(--success-text)] border-[var(--success-border)]' };
    case 'previsto':
      return { label: 'Previsto', className: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]' };
    case 'da_saldare':
      return { label: 'Da Saldare', className: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]' };
    case 'in_ritardo':
      return { label: 'In Ritardo', className: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]' };
    default:
      return { label: status, className: '' };
  }
}

export function getExpenseTypeMeta(type) {
  switch (type) {
    case 'stipendio':
      return { label: 'Stipendio', className: 'bg-[var(--chart-accent-1-soft)] text-[var(--chart-accent-1)] border-[var(--border)]' };
    case 'gestione':
      return { label: 'Gestione', className: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]' };
    case 'spesa_aziendale':
      return { label: 'Spesa Aziendale', className: 'bg-[var(--surface-raised)] text-[var(--text-primary)] border-[var(--border)]' };
    case 'pagamento':
      return { label: 'Pagamento', className: 'bg-[var(--warning-soft)] text-[var(--warning-text)] border-[var(--warning-border)]' };
    default:
      return { label: type, className: '' };
  }
}

export function isWithinNextDays(dateString, days) {
  const currentDate = new Date();
  const dueDate = new Date(dateString);
  const maxDate = new Date(currentDate.getTime() + days * 24 * 60 * 60 * 1000);

  return dueDate >= currentDate && dueDate <= maxDate;
}

export function sortByDueDateDescending(items) {
  return [...items].sort((first, second) => new Date(second.dueDate) - new Date(first.dueDate));
}

export function sortByDueDateAscending(items) {
  return [...items].sort((first, second) => new Date(first.dueDate) - new Date(second.dueDate));
}
